<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            :title="isCreateMode ? 'ADD SAGE NOMINAL CODE' : 'UPDATE SAGE NOMINAL CODE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-nominal-code-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="code" name="code" rules="required" v-slot="{ errors }">
                <small class="label">Code</small>
                <vs-input v-model="form.code"  name="code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="is_for_surcharge" name="is_for_surcharge" rules="" v-slot="{ errors }">
                <small class="label">Mark as Surcharge Code</small>
                <vs-switch class="mb-2" v-model="form.is_for_surcharge"></vs-switch>
                <small class="text-warning">*When enabled, this nominal code will be treated as a surcharge nominal code.</small>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="" v-slot="{ errors }">
                <small class="label">FG Type(s)</small>
                <v-select :clearable="false" placeholder="" v-model="form.formulation_type"
                          :options="['liquid', 'powder', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="sage_supplier_type_id" name="sage_supplier_type_id" rules="" v-slot="{ errors }">
                <small class="label">Sage Supplier Type</small>
                <v-select :clearable="false" placeholder="" v-model="form.sage_supplier_type_id"
                          :options="sage_supplier_types" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name" :reduce="option => option.id">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="sage_department_ids" name="sage_department_ids" rules="" v-slot="{ errors }">
                <small class="label">Sage Departments</small>
                <v-select :clearable="false" placeholder="" v-model="form.sage_department_ids" multiple :closeOnSelect="false"
                          :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name" :reduce="option => option.id">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <vs-button v-if="form.sage_department_ids.length !== sage_departments.length" @click.stop="onClickSelectAllSageDepartment" size="small" class="ml-4">Select all</vs-button>
            <vs-button v-if="form.sage_department_ids.length > 0" @click.stop="onclickRemoveAllSageDepartment" color="danger" size="small" class="ml-4">Clear all</vs-button>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="regions" name="regions" rules="" v-slot="{ errors }">
                <small class="label">Regions</small>
                <v-select :clearable="false" placeholder="" v-model="form.region_ids" multiple :closeOnSelect="false"
                          :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name" :reduce="option => option.id">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <vs-button v-if="form.region_ids.length !== regions.length" @click.stop="onClickSelectAllRegion" size="small" class="ml-4">Select all</vs-button>
            <vs-button v-if="form.region_ids.length > 0" @click.stop="onclickRemoveAllRegion" color="danger" size="small" class="ml-4">Clear all</vs-button>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'create-edit-sage-nominal-code'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSupplierTypeSettingsRepository = RepositoryFactory.get('sage_supplier_type')

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        code: '',
        name: '',
        sage_supplier_type_id: '',
        sage_department_ids: [],
        region_ids: [],
        is_for_surcharge: false
      },
      isCreateMode: true,
      sage_departments: [],
      regions: [],
      sage_supplier_types: [],
    }
  }

  export default {
    name: 'CreateSageNominalCodePopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          await this.fetchRegions()
          await this.fetchSageDepartments()
          await this.fetchSageSupplierTypes()
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchNominalCodeDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchNominalCodeDetails() {
        await this.$vs.loading({
          container: '#create-nominal-code-popup',
          scale: 0.45
        })
        try {
          const {data} = (await SageSettingsRepository.getSageNominalCode(this.id)).data
          this.form = data
          this.form.region_ids = data.regions.map((x) => x.id)
          this.form.sage_department_ids = data.sage_departments.map((x) => x.id)
          this.form.sage_supplier_type_id = data.type.id
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-nominal-code-popup > .con-vs-loading')
      },
      async fetchRegions() {
        await this.$vs.loading({
          container: '#create-nominal-code-popup',
          scale: 0.45
        })
        try {
          const {data} = await RegionsRepository.getListOfRegions(1, '', 100)
          this.regions =  data.data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-nominal-code-popup > .con-vs-loading')
      },
      async fetchSageDepartments() {
        await this.$vs.loading({
          container: '#create-nominal-code-popup',
          scale: 0.45
        })
        try {
          const {data} = await SageSettingsRepository.getListOfSageDepartments(null, '', null, 0 )
          this.sage_departments =  data.data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-nominal-code-popup > .con-vs-loading')
      },
      async fetchSageSupplierTypes() {
        await this.$vs.loading({
          container: '#create-nominal-code-popup',
          scale: 0.45
        })
        try {
          const {data} = await SageSupplierTypeSettingsRepository.getListOfSageSupplierTypeNoPagination('')
          this.sage_supplier_types =  data.data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-nominal-code-popup > .con-vs-loading')
      },
      async onClickCreateSite() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-nominal-code-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await SageSettingsRepository.createSageNominalCode(this.form);
            this.showSuccessMessage('Sage nominal code added successfully!');
          } else {
            this.form.is_for_surcharge = this.form.is_for_surcharge ? true : false
            await SageSettingsRepository.updateSageNominalCode(this.id, this.form);
            this.showSuccessMessage('Sage nominal code updated successfully!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-nominal-code-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-nominal-code-popup > .con-vs-loading')
      },
      onClickSelectAllSageDepartment(){
        this.form.sage_department_ids.splice(0,this.form.sage_department_ids.length)
        this.sage_departments.map((department) => {
          this.form.sage_department_ids.push(department.id)
        })
        // this.form.sage_department_ids = this.sage_departments.map((department) => department.id)
      },
      onclickRemoveAllSageDepartment(){
        this.form.sage_department_ids.splice(0,this.form.sage_department_ids.length)
      },
      onClickSelectAllRegion(){
        this.form.region_ids.splice(0,this.form.region_ids.length)
        this.regions.map((region) => {
          this.form.region_ids.push(region.id)
        })
      },
      onclickRemoveAllRegion(){
        this.form.region_ids.splice(0,this.form.region_ids.length)
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
